import { render, staticRenderFns } from "./updatePart.vue?vue&type=template&id=6be2ea3e&scoped=true&"
import script from "./updatePart.vue?vue&type=script&lang=js&"
export * from "./updatePart.vue?vue&type=script&lang=js&"
import style0 from "./updatePart.vue?vue&type=style&index=0&id=6be2ea3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2ea3e",
  null
  
)

export default component.exports